export const isBrowser = () => typeof window !== 'undefined';

export const printError = (e) => {
  if (process.env.GATSBY_CONTEXT !== 'production') {
    console.error(e);
  }
};
